import moment from "moment";
import { toInteger, forEach, trim } from "lodash-es";
const { $ } = window

const requiredAttr = {
  startDate: "",
  startTime: "00:00",
  endDate: "",
  endTime: "00:00",
  quantityAvailable: 0,
  restaurantId: ""
};

export function setupOverrideForm(container) {
  let startDate = new Date()
  let startDatePicker = { destroy: () => { } }
  let endDatePicker = { destroy: () => { } }

  const selectRestaurant = container.find('.pick_restaurant')
  let selectedRestaurantId
  var selectedInventory = window.selectedInventory || {}

  container.find('.show-after-choose-restaurant').addClass('hidden')
  selectRestaurant.change(() => {
    startDatePicker.destroy()

    selectedRestaurantId = selectRestaurant.val()
    requiredAttr['restaurantId'] = selectedRestaurantId
    $('.start-date-field, .end-date-field').val('')
    container.find('.show-after-choose-restaurant').removeClass('hidden')

    if (selectedInventory.startTime) {
      container.find(".timeModalClass").val(selectedInventory.startTime)
      container.find(".endTimeModalClass").val(selectedInventory.endTime)
    }

    const isFlaggedUrl = $('.is-flagged-url').val()
    $.get(`${isFlaggedUrl}&restaurant_id=${selectedRestaurantId}`).done((flagData) => {

      container.find('.inventory-quantity-available-class').attr('value', flagData.available_seat_after_blocking).attr('min', flagData.available_seat_after_blocking)
      container.find('.inventory-quantity-available').text("*You cannot reduce the seats below [" + flagData.available_seat_after_blocking + "] Seats , please")
      requiredAttr['quantityAvailable'] = selectedInventory['quantityAvailable']

      container.find('.inventory-quantity-available-class').change(() => {
        requiredAttr['quantityAvailable'] = $('.inventory-quantity-available-class').val()
      })

      container.find('#timeModal').change(() => {
        requiredAttr['startTime'] = container.find('#timeModal').val()
      })

      container.find('#endTimeModal').change(() => {
        requiredAttr['endTime'] = container.find('#endTimeModal').val()
      })

      if (flagData.is_flagged) {
        startDatePicker = new Pikaday({
          field: container.find(".start-date-field")[0],
          minDate: startDate,
          defaultDate: startDate,
          maxDate: moment(startDate)
            .add(1, "day")
            .toDate(),
          setDefaultDate: false,
          onSelect() {
            startDate = startDatePicker.getDate();
            requiredAttr['startDate'] = this.toString();
            endDatePicker.destroy();

            setTimeout(() => {
              endDatePicker = new Pikaday({
                field: container.find(".end-date-field")[0],
                minDate: new Date(),
                defaultDate: startDate,
                setDefaultDate: false,
                maxDate: moment(new Date())
                  .add(1, "day")
                  .toDate(),
                onSelect() {
                  requiredAttr['endDate'] = this.toString();
                }
              });
            }, 500)
          },
        });
      } else {
        startDatePicker = new Pikaday({
          field: container.find(".start-date-field")[0],
          minDate: startDate,
          defaultDate: startDate,
          setDefaultDate: false,
          onSelect() {
            startDate = startDatePicker.getDate();
            requiredAttr['startDate'] = this.toString();
            endDatePicker.destroy();

            setTimeout(() => {
              endDatePicker = new Pikaday({
                field: container.find(".end-date-field")[0],
                minDate: startDate,
                defaultDate: startDate,
                setDefaultDate: false,
                maxDate: moment(startDate)
                  .add(1, "day")
                  .toDate(),
                onSelect() {
                  requiredAttr['endDate'] = this.toString();
                }
              });

              if (selectedInventory.endDate) {
                endDatePicker.setDate(selectedInventory.endDate)
              }
            }, 500)
          },
        });
        if (selectedInventory.startDate) {
          startDatePicker.setDate(selectedInventory.startDate)
        }

        if (selectedInventory.quantityAvailable) {
          container.find('.inventory-quantity-available-class').val(selectedInventory.quantityAvailable)
        }
      }
    })
  })

  if (selectedInventory.restaurantId) {
    selectedRestaurantId = selectedInventory.restaurantId
    selectRestaurant.val(selectedRestaurantId).trigger('change')
  } else {
    let options = selectRestaurant.find('option')
    if (options.length == 1) {
      const option = $(options[0])
      option.attr('selected', 'selected')
      selectRestaurant.val(option.attr('value')).change()
    }
  }
}

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function validateOverrideForm() {
  let message = "";
  let emptyAttr = [];
  let invalidAttr = [];
  for (let key in requiredAttr) {
    let formattedKey = capitalize(key.replace(/([A-Z])/g, ' $1').trim());
    if (key === "quantityAvailable" && toInteger(requiredAttr[key]) <= 0) {
      invalidAttr.push("Seats Available");
      continue;
    }
    if (!requiredAttr[key]) {
      emptyAttr.push(formattedKey);
    }
  }

  if (emptyAttr.length > 0) {
    message += "Please fill in " + emptyAttr.join(", ") + ".";
  }
  if (invalidAttr.length > 0) {
    if (message != "") {
      message += " And "
    }
    message += invalidAttr.join(", ") + " must be greater than 0.";
  }

  return {
    isValid: emptyAttr.length === 0 && invalidAttr.length === 0,
    message: message
  }
}

export function submitOverrideForm(event, modal, onFailed) {
  const qa = $(modal.find("input")[4]).val();

  if (toInteger(qa) < 0) {
    event.preventDefault();
    onFailed("Invalid quantity available seat")
    return false;
  }
  return true;
}
